import React from "react";
import Btn from "../../Shared/Lib/Btn/Btn";
import Airplane from "../../Shared/Svgs/Airplane";
import View from "../../Shared/Svgs/View";
import Upload from "../../Shared/Svgs/Upload";
import useStore from "../../../../js/state/state";

const uploadData = () => {
    console.log("upload function");
};

const Projects = () => {
    const { projects } = useStore();

    return (
        <div className="Projects">
            <div className="projectsHeader">
                <div className="titleContent">
                    <Airplane />
                    <h2>Active Projects</h2>
                </div>
                <div className="tableHeaders">
                    <span>Counterparty</span>
                    <span>Effective Date</span>
                    <span>Status</span>
                    <span>Region</span>
                </div>
                <Btn
                    className="projectHeaderBtn"
                    Svg={Upload}
                    cta="Upload"
                    onClick={uploadData}
                />
            </div>

            <div className="projectsTable">
                {projects.map((project, index) => (
                    <div className="tableRow" key={index}>
                        <span className="tableCell title">
                            {project.title}
                        </span>
                        <span className="tableCell">
                            {project.counterparty || "N/A"}
                        </span>
                        <span className="tableCell">
                            {project.effectiveDate || "N/A"}
                        </span>
                        <span
                            className={`tableCell status ${
                                project.isPositive
                                    ? "active"
                                    : "critical"
                            }`}
                        >
                            {project.status}
                        </span>
                        <span className="tableCell">
                            {project.region || "N/A"}
                        </span>
                        <span className="tableCell">
                            <Btn
                                className="emptyBtn"
                                Svg={View}
                                cta="View"
                                onClick={() =>
                                    console.log(
                                        `Viewing project: ${project.title}`
                                    )
                                }
                            />
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Projects;
